<template>
  <div>
    <CRow>
      <CCol  col="12 col-sm-8">
        <CCard>
          <CCardHeader>
            <strong>لاین ها</strong>

          </CCardHeader>
          <CCardBody>
            <div>
            </div>
          </CCardBody>

        </CCard>

        <CCard v-for="item in items">
          <CCardHeader>
           <CCol col="6">
             <div class="d-flex" style="align-items: center;">
               <img :src="item.logo" class="rounded-circle"  width="70px" height="70px"/>
               <div class="mx-2">
                 {{ item.title }}
               </div>

             </div>

           </CCol>
            <CCol col="6">
              <CButton
                  v-if="get_access('reserve_times')"

                  color="danger"
                  variant="outline"
                  square
                  class="mr-1"

                  size="sm"
                  @click="delete_line_dialog(item)"
              >حذف لاین
              </CButton>
           </CCol>
            <hr>

          </CCardHeader>
          <CCardBody>

            <CButton
                v-if="get_access('reserve_times')"
                color="primary"
                variant="outline"
                square
                class="mr-1"
                size="sm"
                @click="add_user_to_line(item)"
            >افزودن عضو
            </CButton>

            <div v-for="admin in item.admins">
              <div class="d-flex" style="align-items: center;">
                <img :src="admin.admin.image" class="rounded-circle p-2"  width="70px" height="70px"/>
                <div class="mx-2">
                  {{ admin.admin.name }}
                </div>
                <CButton
                    v-if="get_access('reserve_times') || my_user_id == admin.admin.id"

                    color="primary"
                    variant="outline"
                    square
                    class="mr-1"
                    size="sm"
                    @click="go_to_reservation(item,admin)"
                >ساعات رزرو
                </CButton>

                <CButton
                    v-if="get_access('reserve_times') || my_user_id == admin.admin.id"
                    color="success"
                    square
                    class="mr-1"
                    size="sm"
                    @click="go_to_reserve_list(item,admin)"
                >لیست رزرو
                </CButton>
                <CButton
                    v-if="get_access('reserve_times')"

                    color="primary"
                    variant="outline"
                    square
                    class="mr-1"
                    size="sm"
                    @click="editDetails(item)"
                ><CIcon name="cil-pencil" size="sm"/>
                </CButton>

                <CButton
                    v-if="get_access('reserve_times')"

                    color="danger"
                    variant="outline"
                    square
                    class="mr-1"

                    size="sm"
                    @click="delete_user_dialog(item,admin)"
                >حذف عضو
                </CButton>
                <hr>
              </div>
            </div>

          </CCardBody>
        </CCard>

      </CCol>
      <CCol  col="12 col-sm-4" v-if="get_access('reserve_times')">
        <CCard>
          <CCardHeader>
            <strong>ثبت لاین</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <CInput
                    v-model="name"
class="required"
                    :label="$t('table_name')"
                />
              </CCol>
              <CCol col="12">
                <ImageSelector label="تصویر"
                               class="required"
                               :media_id.sync="file"
                               default_archive="blog_category"
                               :preview-image="previewImage"
                />

              </CCol>

            </CRow>


          </CCardBody>
          <CCardFooter>
            <CButton v-if="status_form==0"
                @click="login()"
                type="submit" ref="submit_form" size="sm" color="primary">
              ثبت لاین
            </CButton>

            <CButton v-if="status_form!=0"
                     @click="login()"
                     class="mr-1"
                     size="sm" color="warning">
              ویرایش لاین
            </CButton>
            <CButton v-if="status_form!=0"
                     @click="cancel_form()"
                     class="mr-1"

                     size="sm" color="danger">
              {{ $t('cancel') }}
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
        title="ثبت عضو"
        color="info"
        :closeOnBackdrop="false"
        :show.sync="dialog_add_user"
    >
      <treeselect
          v-model="selected_user_to_add"
          :multiple="false"
          :async="true"
          :load-options="load_users"
          placeholder="انتخاب عضو"
          :normalizer="normalizer_admins"
      />

      <template #footer>
        <CButton @click="dialog_add_user = false" color="danger">انصراف</CButton>
        <CButton @click="dialog_add_user=false,add_admin()" color="success">تایید</CButton>
      </template>
    </CModal>
  </div>

</template>

<script>
import axios from "axios";

import {bus} from '../../main';
import Treeselect, {ASYNC_SEARCH} from "@riophae/vue-treeselect";
const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}

export default {
  name: 'Login',
  components: {Treeselect},
  data() {
    return {
      my_user_id:0,
      confirm_delete_user:new Date().getTime()+"_"+this.$vnode.tag+"user",
      confirm_delete_line:new Date().getTime()+"_"+this.$vnode.tag+"line",
      name: '',
      code: '',
      dialog_add_user:false,
      file: [],
      color: '',
      previewImage: null,
      description: '',
      selected_line: 0,
      selected_user_to_add:null,
      items: [],
      fields: [
        {key: 'row',label: '#', _style: 'width:7%'},
        {key: 'logo',label: 'تصویر', _style: 'width:20%'},
        {key: 'title',label: 'نام', _style: 'width:20%'},
        {key: 'operation',label: 'عملیات', _style: 'width:10%;'},

      ],

      status_form: 0,
      status_form_admin: 0,
      normalizer_admins(node) {
        return {
          id: node.id,
          label: node.name + " " + node.phone,
        }
      },
    }
  },
  mounted() {
    this.my_user_id = localStorage.getItem('user_id')
    this.get_categories();
    bus.$on(this.confirm_delete_user, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_admin();

      } else {
        this.status_form = 0;
      }
    });
    bus.$on(this.confirm_delete_line, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_line();

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {
    '$route.params.cat_id': function () {
      this.get_categories();
    }
  },
  methods: {
    load_users({action, searchQuery, callback}) {

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          var formData = new FormData();
          formData.append('search', searchQuery);
          axios.post('/api/admin/user/search-admin', formData, {}).then(function (response) {
            options = response.data;
            callback(null, options);
          })
              .catch(function (error) {
                console.log(error);
              });

        })
      }
    },

    add_user_to_line(item){
      this.selected_line = item.id
this.dialog_add_user = true
    },
    cancel_form() {
      this.name = '';
      this.description = '';
      this.previewImage = null;
      this.file = [];

      this.status_form = 0;

    },
    editDetails(item) {
      this.name = item.title;
      this.code = item.code;
     this.status_form = item.id;

    },
    go_to_reservation(item,admin){
      this.$router.push({path:'/dashboard/lines/reserve_times/'+item.id+'/'+admin.admin.id})
    },
    go_to_reserve_list(item,admin){
      this.$router.push({path:'/dashboard/lines/reservations/'+item.id+'/'+admin.admin.id})
    },
    get_categories() {
      var self = this;
var formData = new FormData();

      axios.post('/api/admin/site/get_lines',formData, {}).then(function (response) {

        var content_cats = response.data;

        self.items = content_cats.orders.map((item, row_id) => {
          return {...item, row_id}
        })

      })
          .catch(function (error) {

            console.log(error);
          });

    },


    login() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/site/add_line";
      } else {

        url = "/api/admin/site/update_line";
        formData.append('id', this.status_form)

      }

      formData.append('image', this.file[0]);

      formData.append('name', this.name);
      formData.append('code', this.code);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        if (res.data.error == 0) {
          self.name = '';
          self.code = '';
          self.description = '';
          self.previewImage = '';
          self.previewImage_header = '';
          self.status_form = 0;
          self.get_categories();
        }

      })


          .catch(function (error) {

            console.log(error);
          });

    },
    add_admin() {


      let self = this;
      const formData = new FormData()
      let url;
      if (this.status_form == 0) {
        url = "/api/admin/site/add_line_admin";
      } else {
        formData.append('id', this.status_form)
      }

      formData.append('id', this.selected_line);

      formData.append('user_id', this.selected_user_to_add);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        if (res.data.error == 0) {

          self.get_categories();
        }

      })


          .catch(function (error) {

            console.log(error);
          });

    },
    delete_line_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("warning"), this.$t("deleteMessage"), [this.$t("ok")], this.confirm_delete_line);

      this.status_form = item.id;

    },
    delete_user_dialog(item,admin) {
      this.$root.modal_component.show_confirm_modal(this.$t("warning"), this.$t("deleteMessage"), [this.$t("ok")], this.confirm_delete_user);

      this.status_form = item.id;
      this.status_form_admin = admin.id;

    },
    delete_line() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/delete_line";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_categories();


      })
          .catch(function (error) {
            console.log(error);
          });
    },
    delete_admin() {
      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/site/delete_line_admin";

      formData.append('id', this.status_form);
      formData.append('user_id', this.status_form_admin);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        self.status_form = 0;

        self.get_categories();


      })
          .catch(function (error) {
            console.log(error);
          });
    },
  }
}


</script>
